import { useTranslate } from "@similarweb/i18n-provider";

import { objectKeys } from "app/helpers/objects";
import type { IFilterViewBaseModelProps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterInstance";

import { type AppOperatingSystem, appOperatingSystemMap } from "../../../types/commonFiltersDto";
import appsSearchFiltersI18nKeys from "../../../utils/i18n";

import { StyledAppsPlatformContainer, StyledAppsPlatformGroup, StyledRadioButton } from "./styles";

const AppsPlatformFilter = ({
    value,
    onFilterUpdate,
}: IFilterViewBaseModelProps<AppOperatingSystem, readonly AppOperatingSystem[]>) => {
    const { translate } = useTranslate();

    return (
        <StyledAppsPlatformContainer>
            <StyledAppsPlatformGroup data-automation="apps-platform-radio-group">
                {objectKeys(appOperatingSystemMap).map((appOs) => (
                    <StyledRadioButton
                        key={appOs}
                        buttonSize="sm"
                        itemLabel={translate(appsSearchFiltersI18nKeys.appPlatformTaxonomy(appOs))}
                        itemSelected={value === appOs}
                        onClick={() => onFilterUpdate(appOs)}
                    />
                ))}
            </StyledAppsPlatformGroup>
        </StyledAppsPlatformContainer>
    );
};

export default AppsPlatformFilter;
